<template>
  <button
    :type="type"
    :class="['btn btn-dark ', `btn-${variant}`]"
    :disabled="disabled || loading"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
    
    <!-- Icono opcional (antes del texto) -->
    <i v-if="icon && !loading" :class="['fas', icon, label ? 'mr-1' : '']"></i>

    <!-- Slot para contenido personalizado o etiqueta simple -->
    <slot>
      {{ label }}
    </slot>
  </button>
</template>

<script>
export default {
  name: 'ButtonProvider',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'primary' // primary, secondary, success, danger, warning, info, light, dark, link
    },
    type: {
      type: String,
      default: 'button'
    },
    icon: {
      type: String,
      default: '' // Ejemplo: 'fa-plus', 'fa-trash'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
/* Estilos adicionales si fueran necesarios */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
